import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyC2wJWK-WMBFuk5xnKbjPi-EcCl0KecqrQ",
  authDomain: "wire-stay.firebaseapp.com",
  databaseURL: "https://wire-stay-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "wire-stay",
  storageBucket: "wire-stay.firebasestorage.app",
  messagingSenderId: "482517957206",
  appId: "1:482517957206:web:adbf93eb7a8782d98219f7",
  measurementId: "G-7L0L4T2SME"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

const VAPID_KEY = "BLtetolpr_Gbdq27DUftZz-hqZgUdZhIVP_NOwgE6F8I3xs4714AmRm_g48f4PwwLupM4Pk5jVi_-dcuVbXfWQs";

export const getFCMToken = async () => {
  try {
    if (Notification.permission === 'denied') {
      toast.error('Notifications are blocked. Please enable them from your browser settings.');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      toast.error('Notification permission denied.');
      return null;
    }

    const swReg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log('Service Worker Registered:', swReg);

    const fcmToken = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: swReg,
    });

    if (fcmToken) {
      console.log('FCM Token:', fcmToken);
      await sendTokenToBackend(fcmToken);
      return fcmToken;
    } else {
      toast.error('Could not get notification token.');
      return null;
    }
  } catch (err) {
    console.error('Error generating or sending FCM token:', err);
    toast.error('Error setting up push notifications.');
    return null;
  }
};

const sendTokenToBackend = async (fcmToken) => {
  try {
    const hostData = getItemFromLocalStorage('hostProfile');
    if (!hostData || !hostData.host_access_token) {
      console.warn('Host profile data or access token not found in local storage.');
      return;
    }

    let formData = new FormData();
    formData.append('push_token', hostData.host_access_token);
    formData.append('push_device', 'web');
    formData.append('push_user_type', 'host');
    formData.append('push_id', fcmToken);

    const response = await axios({
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      url: `${params.baseURL}${params.endpoints.saveVisitor}`,
      data: formData
    });

    console.log('Backend response for saving FCM token:', response.data);

    if (response.data.status === 'success') {
      toast.success('Push Notifications Enabled!');
    } else if (response.data.status === 'error') {
      toast.error(response.data.message || 'Failed to enable push notifications.');
    } else {
      toast.error('Unknown response from backend while saving push token.');
    }
  } catch (err) {
    console.error('Error sending FCM token to backend:', err);
    toast.error('Error connecting to server for push notifications.');
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Foreground message received:', payload);
      resolve(payload);
    });
});

export default firebaseApp;